/**
 * AreaOfEffectShape enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file AreaOfEffectShape.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum AreaOfEffectShape {
  CIRCLE = 0,
  RECTANGLE = 1,
}